var Toast = /** @class */ (function () {
    function Toast(el) {
        this.el = el;
    }
    Toast.success = function (message, icon_class) {
        if (icon_class === void 0) { icon_class = 'fas fa-check-circle'; }
        return Toast.showMessage(message, 'is-success', icon_class);
    };
    Toast.error = function (message, icon_class) {
        if (icon_class === void 0) { icon_class = 'fas fa-times-circle'; }
        return Toast.showMessage(message, 'is-error', icon_class);
    };
    Toast.showMessage = function (message, message_class, icon_class) {
        var toast = document.createElement('div');
        toast.className = "tc-toast ".concat(message_class, " animated is-hidden");
        toast.innerHTML =
            "<div class=\"columns\">\n                    <div class=\"column is-vcentered\">\n                        <i class=\"".concat(icon_class, " has-margin-right-100 fa-2x is-pulled-left\">&nbsp;</i>").concat(message, "\n                    </div>\n                </div>\n            </div>");
        document.body.appendChild(toast);
        return new Toast(toast).show();
    };
    Toast.prototype.show = function () {
        var _this = this;
        this.el.classList.add('fadeInUp');
        this.el.classList.remove('is-hidden');
        this.afterAnimation(function () {
            _this.hideTimeout = setTimeout(function () { return _this.hide(); }, 5000);
        });
        this.el.addEventListener('click', function () {
            if (_this.hideTimeout) {
                clearTimeout(_this.hideTimeout);
            }
            _this.hide();
        });
    };
    Toast.prototype.hide = function () {
        var _this = this;
        this.el.classList.remove('fadeInUp');
        this.el.classList.add('fadeOutDown');
        this.afterAnimation(function () {
            _this.el.remove();
        });
    };
    Toast.showToasts = function () {
        document.querySelectorAll('.tc-toast').forEach(function (el) {
            new Toast(el).show();
        });
    };
    Toast.prototype.afterAnimation = function (callback) {
        var _this = this;
        var cb = function () {
            _this.el.removeEventListener('animationend', cb);
            callback();
        };
        this.el.addEventListener('animationend', cb);
    };
    return Toast;
}());
export default Toast;
